export default function Footer() {
  return (
    <footer
      className="footer"
    >
      Made in Texas.
    </footer>
  )
}